module.exports = __webpack_public_path__ + "img/Skirt-Back-B4-Da-Fb-Gb-Hc-Ia-Ga.00c6f44e.png";